import React from 'react'
import style from './TextContent.module.css'

const TextContent = () => {
    return (
        <div className={style.TextContent}>
            <h1 className={style.mainHeading}>Sri Krishna Janmashtami Celebrations 2025 | ISKCON Vijayawada</h1>

            <p className={style.patagContent}>
                Thank you for visiting us. We joyfully welcome you to the ISKCON Vijayawada devotional family. Feel free to connect with us for guidance, to offer your service to Sri Sri RadhaShyam Sundar or Sri Jagannath, Baldev, and Subhadra, or seek information about our spiritual programs, services, or courses, please reach out. We deeply value your suggestions and are always here to serve you. Hare Krishna!
            </p>

            <h2 className={style.FHheading}>Festival Highlights</h2>
        </div>
    )
}

export default TextContent
